module finadai.app.agents.create {
  export var NAME = 'finadai.app.agents.create'
  function AgentsCreateController($scope, agentsService: finadai.services.AgentsService, notify, $state, data){
    $scope.agentData = data;
    $scope.isCreate = $state.is('app.agents.create')
    $scope.submit = (form: ng.IFormController) => {
      if(form.$valid){
        agentsService.save($scope.agentData).then(response => {
          notify('Registro guardado');
          $state.go('app.agents.list');
        });
      }
    }
  }
  export function run(){
    var create = angular.module(NAME, []);
    create.controller('AgentsCreateController', AgentsCreateController);
  }
}
finadai.app.agents.create.run();